import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button, Alert, Box, Card, CardContent, Typography } from "@mui/material";
import { signInWithEmailAndPassword, getAuth } from "firebase/auth";
import { loginWithGoogle } from "./firebaseServices";
import GoogleIcon from "@mui/icons-material/Google";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    try {
      await loginWithGoogle();
      navigate("/");
    } catch (err) {
      setError("Google sign-in failed. Please try again.");
    }
  };

  const handleEmailLogin = async () => {
    try {
      setError("");
      const auth = getAuth();
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/");
    } catch (err) {
      setError("Login failed. Check your email and password.");
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f4f4f4">
      <Card sx={{ width: 350, textAlign: "center", padding: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5">Log in to Distributor Images</Typography>

          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}

          <TextField label="Email" variant="outlined" fullWidth sx={{ my: 2 }} value={email} onChange={(e) => setEmail(e.target.value)} />

          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            sx={{ mb: 2 }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button variant="contained" color="primary" fullWidth sx={{ mb: 2 }} onClick={handleEmailLogin}>
            Log in with Email
          </Button>

          <Button variant="contained" color="secondary" fullWidth startIcon={<GoogleIcon />} onClick={handleGoogleLogin}>
            Sign in with Google
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}

export default Login;
